import Icon from '../components/Icon';

const List = Icon(
  'list',
  <>
    <path d="M5.25 6A1.125 1.125 0 1 1 3 6a1.125 1.125 0 0 1 2.25 0M8.25 5.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zM8.25 11.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zM7.5 18a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 18M4.125 13.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M5.25 18A1.125 1.125 0 1 1 3 18a1.125 1.125 0 0 1 2.25 0" />
  </>
);

export default List;
